import React, { useState } from "react";
import { useSelector } from "react-redux";

import PostHustle from "./PostHustle";
import HustlersAvailable from "./HustlersAvailable";
import HustleList from "./HustleList";
import HustleFlywheel from "./help/HustleFlywheel";

export default function HustlesHome() {
    const authState = useSelector((state) => state.authReducer);

    const userId = authState?.user?._id || null;
    const userCode = authState?.user?.think5whyscode || "";
    const userName = authState?.user?.name || "User";

    const [showDoor, setShowDoor] = useState(true);
    const [tab, setTab] = useState("");

    const go = (value) => setTab(value);

    const tabs = [
        ["POST_HUSTLE", "Post", "fa-plus-circle"],
        ["AVAILABLE_HUSTLERS", "I Am Available", "fa-users"],        
        ["FREELANCE", "Freelance", "fa-laptop-code"],
        ["MICRO_TASK", "Micro Tasks", "fa-bolt"],
        ["REMOTE_WORK", "Remote Work", "fa-globe"],
        ["WOMEN_JOBS", "Women Jobs", "fa-female"],
        ["DIGITAL_BOUTIQUE", "Boutique", "fa-store"],
        ["DIGITAL_FRANCHISE", "Franchise", "fa-handshake"],
        ["FACTORY", "Factory", "fa-industry"],
        ["STARTUP", "Startup", "fa-rocket"],
        ["RETAIL", "Retail", "fa-bag-shopping"],
        ["CONTRACTING", "Contracting", "fa-hard-hat"],
        // ["HUSTLES_LIST", "Listing", "fa-list"],
    ];

    const hustleTabs = [
        "FREELANCE",
        "MICRO_TASK",
        "REMOTE_WORK",
        "WOMEN_JOBS",
        "DIGITAL_BOUTIQUE",
        "DIGITAL_FRANCHISE",
        "FACTORY",
        "STARTUP",
        "RETAIL",
        "CONTRACTING",
        "HUSTLES_LIST",
    ];

    const renderContent = () => {
        if (hustleTabs.includes(tab)) {
            return <HustleList hustleType={tab} />;
        }
        switch (tab) {
            case "POST_HUSTLE":
                return <PostHustle userId={userId} userCode={userCode} />;

            case "AVAILABLE_HUSTLERS":
                return <HustlersAvailable userId={userId} />;

            default:
                return <HustleFlywheel />;
        }
    };

    return (
        <div className="min-h-screen bg-[#0b0f19] text-white flex flex-col">
            <div className="sticky top-0 z-10 bg-[#111827] border-b border-gray-800 px-3 py-3">
                <div className="text-cyan-400 font-bold text-xs lg:text-sm">
                    💼 Hustles/ Opportunity Hub for Younger Generations of the World
                </div>
                <div className="text-[10px] text-gray-400">
                    {userName} • {userCode}
                </div>
            </div>

            <div className="grid grid-cols-4 lg:grid-cols-10 px-4 py-2 bg-[#111827] border-t-2 border-cyan-200 rounded-2xl gap-0.5">
                {tabs.map(([id, label, icon]) => (
                    <button
                        key={id}
                        onClick={() => go(id)}
                        className={`flex flex-col items-center justify-center px-3 py-1 min-w-[72px] transition-all duration-200 relative
                            ${
                                tab === id
                                    ? "text-cyan-400"
                                    : "text-gray-200"
                            }
                        `}
                    >
                        <i className={`fa ${icon} text-xs`} />

                        <span className="text-[11px] lg:text-sm leading-none whitespace-nowrap">
                            {label}
                        </span>
                        {tab === id && (
                            <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-5 h-[2px] bg-cyan-400 rounded-full" />
                        )}
                    </button>
                ))}
            </div>
            <div className="flex-1 overflow-y-auto px-3 pb-4">
                {renderContent()}
            </div>
        </div>
    );
}